
export const SET_FEEDBACK = "SET_CUSTOMER_DATA";
export const LOGOUT = "CLEAR_COMMON_STATE";
export const CLEAR_FEEDBACK_STATE = "CLEAR_FEEDBACK_STATE";